import { Grid, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { useTheme } from "@mui/material/styles";

import { LogOut, Settings, User } from "lucide-react"
import { Separator } from "../../../components/ui/separator"
import { logoutUser } from "../../../utils/helpers/CommonFunction";
import { useRef, useState } from "react";
import { useRouter } from "../../../hooks/use-router";
import { useSelector } from "react-redux";

export const MenuCardList = ({setOpen}:{setOpen: (event: any)=>void}) =>{
    const theme = useTheme();
    const router = useRouter()
    const customization = useSelector((state: any) => state.customization);

  const anchorRef = useRef<any>(null);

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleListItemClick = (event: any, index: any, route = "") => {
    setSelectedIndex(index);
    setOpen(event);

    if (route && route !== "") {
        router.push(route);
    }
  };

    const handleLogout = async () => {
        logoutUser();
      };

    return(
        <div >
        <List
          component="nav"
          sx={{
            width: "100%",
            maxWidth: 350,
            minWidth: 300,
            backgroundColor: theme.palette.background.paper,

            [theme.breakpoints.down("md")]: {
              minWidth: "100%",
            },
            // "& .MuiListItemButton-root": {
            //   mt: 0.5,
            // },
          }}
        >
         
          <ListItemButton
            sx={{ borderRadius: `${customization.borderRadius}px` }}
            selected={selectedIndex === 1}
            onClick={(event) => handleListItemClick(event, 1, "/profile")}
          >
            <ListItemIcon>
              <User/>
            </ListItemIcon>
            <ListItemText
              primary={
                <Grid
                  container
                  spacing={1}
                  justifyContent="space-between"
                >
                  <Grid item>
                    <p className="text-sm font-normal">
                      Profile
                    </p>
                  </Grid>
                  {/* <Grid item>
                    <Chip
                      label="02"
                      size="small"
                      sx={{
                        bgcolor: theme.palette.warning.dark,
                        color: theme.palette.background.default,
                      }}
                    />
                  </Grid> */}
                </Grid>
              }
            />
          </ListItemButton>
          <ListItemButton
            sx={{ borderRadius: `${customization.borderRadius}px` }}
            selected={selectedIndex === 0}
            onClick={(event) => handleListItemClick(event, 0, "/settings")}
          >
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            <ListItemText
              primary={
                <p className="text-sm font-normal">
                  Account Settings
                </p>
              }
            />
          </ListItemButton>
          <Separator />
          <ListItemButton
            sx={{ borderRadius: `${customization.borderRadius}px` }}
            selected={selectedIndex === 4}
            onClick={handleLogout}
          >
            <ListItemIcon>
              <LogOut />
              {/* <Logout /> */}
            </ListItemIcon>
            <ListItemText
              primary={
                <p className="text-sm font-normal">
                Logout
              </p>
              }
            />
          </ListItemButton>
        </List>
      </div>
    )
}